import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "15.997",
      cy: "7.999",
      r: "5.333",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#34C759",
      d: "M26.67 23.334c0 3.314 0 6-10.667 6s-10.667-2.686-10.667-6 4.776-6 10.667-6c5.89 0 10.666 2.686 10.666 6",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }